import React, {useState,useEffect, Fragment} from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RichTextEditor } from '@mantine/rte';
import { rquestions } from "../../apis/urls";
import axios from "axios";
import { $ } from "react-jquery-plugin";

const EditRuleQuestion =()=> {

    const {ruleid, qid} = useParams();

    const navigate = useNavigate();


    const [result, setResult] = useState([]);
    const [ansRes, setAnsRes] = useState([]);

    const [qst, setQst] = useState('');
    const [point, setPoint] = useState('');
    const [type, setType] = useState('');
    const [opt1, setOpt1] = useState('');
    const [opt2, setOpt2] = useState('');
    const [opt3, setOpt3] = useState('');
    const [opt4, setOpt4] = useState('');
    const [ansOpt, setAnsOpt] = useState('');

    const [cAns, setCAns] = useState('');

    const [ans, setAns] = useState(null);
    const [noOfType, setNoOfType] = useState(null);

    const [ questionerror, setQuestionError ] = useState(false)
    const [ markError, setMarkError ] = useState(false)
    const [ qstLengthErr, setQstLengthErr ] = useState(false)
    const [ optionErr, setOptionErr ] = useState(false);
    const [ noOptErr, setNoOfOptErr ] = useState(false);


    useEffect(()=>{
        Listing();
    },[])



    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({
            baseURL: rquestions+"/"+ruleid+"/"+qid,
            timeout: 1000000,
            headers: {'authorization': token}
          });
          
          instance.get('').then((response) =>{

            // console.log('error',response.data.data)

            setQst(response.data.data.question)
            setPoint(response.data.data.mark)
            setType(response.data.data.type)

            if(response.data.data.type === 'MULTIPLE')
            {
                setOpt1(response.data.data.opt1)
                setOpt2(response.data.data.opt2)
                setOpt3(response.data.data.opt3)
                setOpt4(response.data.data.opt4)
            }

            setAns(response.data.data.answer)
            setCAns(response.data.data.correct_ans)

            setResult(response.data.data);

            setNoOfType(response.data.data.option_count)

           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }











    const OnFormClick = () => {


        if(ans === "OPTION1" ||ans === "OPTION2" ||ans === "OPTION3" ||ans === "OPTION4"){

            if((noOfType === 2 || noOfType === "2" ) && type === "MULTIPLE"){
                if(ans !=="OPTION1" && ans !=="OPTION2"){
                    return alert('Please select valid answer')
                }
            }else if((noOfType === 3 || noOfType === "3") && type === "MULTIPLE"){
                if(ans !=="OPTION1" && ans !=="OPTION2" && ans !=="OPTION3"){
                    return alert('Please select valid answer')
                }
            }else if((noOfType === 4 || noOfType === "4") && type === "MULTIPLE"){
                if(ans !=="OPTION1" && ans !=="OPTION2" && ans !=="OPTION3" && ans !=="OPTION4"){
                    return alert('Please select valid answer')
                }
            }

        }

        // alert($('input[name=options]:checked').length);
        // alert($('input[name=boolean]:checked').length)

         if(type==="MULTIPLE")
         {
            // alert(type);
            // alert($('input[name=options]:checked').length);
            if ($('input[name=options]:checked').length === 0) {
                return alert("Please select valid answer")
            }
         }
         else
         {
            // alert("hi");
            // alert(type);
            if($('input[name=boolean]:checked').length === 0)
            {
                return alert("Please select valid answer")
            }
         }
           
          
        
        
       
       
        


        if(type === "MULTIPLE" && (noOfType === "" || noOfType === null)){
            setNoOfOptErr(true)
        }else{
            setNoOfOptErr(false)
        }



        if(qst === ''){
            setQuestionError(true)
        }else{
            setQuestionError(false)
        }


        if(qst !== '' && qst.length < 2){
            setQstLengthErr(true)
        }else{
            setQstLengthErr(false)
        }


        if(point === '' || point === null){
            setMarkError(true)
        }else{
            setMarkError(false)        
        }


        if(noOfType === 2 && (opt1 === '' || opt2 === '')){
            setOptionErr(true)
        }else if(noOfType === 3 && (opt1 === '' || opt2 === ''|| opt3 === '')){
            setOptionErr(true)
        }else if(noOfType === 4 && (opt1 === '' || opt2 === ''|| opt3 === ''|| opt4 === '')){
            setOptionErr(true) 
        }else{
            setOptionErr(false) 
        }
    

        let token = "Bearer "+localStorage.getItem('token');

        if(ans === "OPTION1"){
            setAns(opt1)
        }else if(ans === "OPTION2"){
            setAns(opt2)
        }else if(ans === "OPTION3"){
            setAns(opt3)
        }else{
            setAns(opt4)
        }

        const data = {
        rule_id: ruleid,
        question: qst,
        type: type,
        mark: point,
        option_count:noOfType,
        status:'ACTIVE',
        opt1:opt1,
        opt2:opt2,
        opt3:opt3,
        opt4:opt4,
        ansOpt:ansOpt,
        answer:ans ==="OPTION1"?opt1:ans === "OPTION2"?opt2:ans === "OPTION3"?opt3:ans==="OPTION4"?opt4:ans?ans:null,
        correct_ans:cAns
        }



        // console.log('all datas',typeof point)
        const instance = axios.create({

            baseURL: rquestions+"/"+qid,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.put('',data).then((response) =>{

            navigate("/rules_list_question/"+ruleid)

            console.log("data", data)
           
          }).catch((error) =>{
            

          });
        }

















    
    return(

        <div className="wrapper">

        <aside class="right-side areas">
            
            <div class="content-area">

                <div className="page-title-wrpr">

                    <h2 className="page-title">Update Question</h2>

                </div>




                <nav aria-label="breadcrumb">

                    <ol className="breadcrumb">

                        <li className="breadcrumb-item"><Link to="/rules">Rules Tests</Link></li>

                        <li className="breadcrumb-item"><Link to={"/rules_list_question/"+ruleid}>Manage Questions</Link></li>

                        <li className="breadcrumb-item active" aria-current="page">Update Question</li>

                    </ol>

                </nav>

            </div>





                    <div className="form-wrpr">
                        <div className="card formcard small">
                            <div className="card-body">
                                <div className="form-group">
                                    <label className="degreehead">Question <span style={{color: "red"}}>*</span></label>
                                    <textarea value={qst} type="text" onChange={(e)=>setQst(e.target.value)} className="form-control bg-dark dark-theme showtext"  placeholder="Enter Question" id="name"></textarea>

                                    {
                                        questionerror
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Question</div>
                                        :null
                                    }
                                    {
                                        qstLengthErr
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Question must be more than 2 charactors.</div>
                                        :null
                                    }                                    

                                </div>

                                <div className="form-group">
                                    <label className="degreehead">Points <span style={{color: "red"}}>*</span></label>
                                    <input type="number" value={point} onChange={(e)=>setPoint(e.target.value)} className="form-control bg-dark dark-theme showtext"  placeholder="Enter Points" id="name" />
                                    {
                                        markError
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Mark</div>
                                        :null
                                    }
                                </div>



                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label className="degreehead">Answer type<span style={{color: "red"}}>*</span></label>
                                                <div class="radio-btn-type">                                               
                                                    <label>                            
                                                        <input type="radio" 
                                                            // onClick={openType}  
                                                            checked={type==="BOOLEAN"?true:false}
                                                            name="type"
                                                            onChange={e => {setType(e.target.value)}} 
                                                            value="BOOLEAN"/><span className="new-previous-label">True / False</span>
                                                    </label>
                                                    <label>
                                                        <input type="radio" 
                                                            checked={type==="MULTIPLE"?true:false}
                                                            name="type" 
                                                            onChange={e => {setType(e.target.value)}} 
                                                            value="MULTIPLE"/><span className="new-previous-label">Multiple Choice</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    {type === 'BOOLEAN'?
                                    
                                    


                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="degreehead">Select Answer<span style={{color: "red"}}>*</span></label>
                                                <div class="radio-btn-type">                                               
                                                    <label>                            
                                                        <input type="radio" 
                                                            // onClick={openType}  
                                                            name="boolean"
                                                            checked={cAns === "TRUE"?true:false}
                                                            onChange={e => {setCAns(e.target.value)}} 
                                                            value="TRUE"/><span className="new-previous-label">True</span>
                                                    </label>
                                                    <label>
                                                        <input type="radio"
                                                            checked={cAns === "FALSE"?true:false}
                                                            name="boolean" 
                                                            onChange={e => {setCAns(e.target.value)}} 
                                                            value="FALSE"/><span className="new-previous-label">False</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    
                                    
                                    
                                    :


                                    <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label className="degreehead">No of Options<span style={{color: "red"}}>*</span></label>
                                                <div class="radio-btn-type">                                               
                                                    <label>                            
                                                        <input type="radio" 
                                                            // onClick={openType}  
                                                            name="multiple"
                                                            checked={noOfType===2 || noOfType==="2"?true:false}
                                                            onChange={e => {setNoOfType(2)}} 
                                                            value={2}/><span className="new-previous-label">2</span>
                                                    </label>
                                                    <label>
                                                        <input type="radio" 
                                                            name="multiple" 
                                                            checked={noOfType===3  || noOfType==="3"?true:false}
                                                            onChange={e => {setNoOfType(3)}} 
                                                            value={3}/><span className="new-previous-label">3</span>
                                                    </label>
                                                    <label>
                                                        <input type="radio" 
                                                            name="multiple"
                                                            checked={noOfType=== 4 || noOfType==="4"?true:false}
                                                            onChange={e => {setNoOfType(4)}} 
                                                            value={4}/><span className="new-previous-label">4</span>
                                                    </label>
                                                </div>
                                                {
                                                    noOptErr
                                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please select options count</div>
                                                    :null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    }


                                    {type === "MULTIPLE"?
                                        <Fragment>
                                            {/* <div className="form-group">                
                                                <div className="row">
                                                    <div className="col-md-11">               
                                                        <label className="degreehead">Option 1<span style={{color: "red"}}>*</span></label>     
                                                        <input type="text" className="form-control  justshow bg-dark" 
                                                            value={opt1}
                                                            onChange={(e)=>setOpt1(e.target.value)}
                                                            placeholder="Enter Option" />                 
                                                    </div>
                                                    <div className="col-md-1">
                                                        <div class="radio-btn-type answer-option-radio">    
                                                            <input type="radio"
                                                                onChange={()=>setAns('OPTION1')}    
                                                                checked={ans==="OPTION1"?true:ans === opt1?true:false}    
                                                                name="options" />                                                          
                                                        </div>                                  
                                                    </div>                                                                                                            
                                                </div>
                                            </div>
                                             */}

                                            {noOfType >= 2 || noOfType >= "2"?
                                            <div className="form-group">                
                                                <div className="row">
                                                <div className="col-md-11">               
                                                        <label className="degreehead">Option 1<span style={{color: "red"}}>*</span></label>     
                                                        <input type="text" className="form-control  justshow bg-dark" 
                                                            value={opt1}
                                                            onChange={(e)=>setOpt1(e.target.value)}
                                                            placeholder="Enter Option" />                 
                                                    </div>
                                                    <div className="col-md-1">
                                                        <div class="radio-btn-type answer-option-radio">    
                                                            <input type="radio"
                                                                onChange={()=>setAns('OPTION1')}   
                                                                id="ONE" 
                                                                checked={ans==="OPTION1"?true:ans === opt1?true:false}    
                                                                name="options" />                                                          
                                                        </div>                                  
                                                    </div>   
                                                    <div className="col-md-11">               
                                                        <label className="degreehead">Option 2<span style={{color: "red"}}>*</span></label>     
                                                        <input type="text" className="form-control  justshow bg-dark" 
                                                            value={opt2}
                                                            onChange={(e)=>setOpt2(e.target.value)}
                                                            placeholder="Enter Option" />                 
                                                    </div>
                                                    <div className="col-md-1">
                                                        <div class="radio-btn-type answer-option-radio">    
                                                            <input type="radio"
                                                                id="TWO"
                                                                onChange={()=>setAns('OPTION2')}    
                                                                checked={ans==="OPTION2"?true:ans === opt2?true:false}    
                                                                name="options" />                                                          
                                                        </div>                                  
                                                    </div>                                                                                                            
                                                </div>
                                            </div>:null
                                            }



                                            {noOfType >= 3 || noOfType >= "3"?
                                            <div className="form-group">                
                                                <div className="row">
                                                    <div className="col-md-11">               
                                                        <label className="degreehead">Option 3<span style={{color: "red"}}>*</span></label>     
                                                        <input type="text" className="form-control  justshow bg-dark" 
                                                            value={opt3}
                                                            onChange={(e)=>setOpt3(e.target.value)}
                                                            placeholder="Enter Option" />                 
                                                    </div>
                                                    <div className="col-md-1">
                                                        <div class="radio-btn-type answer-option-radio">    
                                                            <input type="radio"
                                                                id="THREE"
                                                                onChange={()=>setAns('OPTION3')}    
                                                                checked={ans==="OPTION3"?true:ans === opt3?true:false}    
                                                                name="options" />                                                          
                                                        </div>                                  
                                                    </div>                                                                                                            
                                                </div>
                                            </div>:null
                                            }


                                            {noOfType === 4 || noOfType === "4"?
                                                <div className="form-group">                
                                                    <div className="row">
                                                        <div className="col-md-11">               
                                                            <label className="degreehead">Option 4<span style={{color: "red"}}>*</span></label>     
                                                            <input type="text" className="form-control  justshow bg-dark"
                                                                value={opt4}
                                                                onChange={(e)=>setOpt4(e.target.value)}
                                                                placeholder="Enter Option" />    

                                                        </div>
                                                        <div className="col-md-1">
                                                            <div class="radio-btn-type answer-option-radio">    
                                                                <input type="radio"
                                                                id="FOUR"
                                                                onChange={()=>setAns('OPTION4')}    
                                                                checked={ans==="OPTION4"?true:ans === opt4?true:false}    
                                                                    name="options" />                                                          
                                                            </div>                                  
                                                        </div>                                                                                                            
                                                    </div>
                                                </div>:null
                                            }

                                            {
                                                optionErr
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter options</div>
                                                :null
                                            }
                                        </Fragment>:null
                                    }



                                
                                <div className="form-group text-right">
                                    <button onClick={()=>{navigate("/rules_list_question/"+ruleid)}} className="btn btn-primary btn-gisa cancelbtn">Cancel</button>

                                    <button className="btn btn-primary btn-gisa" type="button" onClick={OnFormClick}>Update</button>

                                </div>

                            </div>
                        </div>
                        
                    </div>











        </aside>

    </div>
    )
}

export default EditRuleQuestion